export const questionsData = [
  {
    id: 1,
    question: "Rolex is a company that specializes in what type of product?",
    answers: [
      { text: "Phone", correct: false },
      { text: "Watches", correct: true },
      { text: "Food", correct: false },
      { text: "Cosmetics", correct: false },
    ],
  },
  {
    id: 2,
    question: "When did the website Facebook launch?",
    answers: [
      { text: "2004", correct: true },
      { text: "2005", correct: false },
      { text: "2006", correct: false },
      { text: "2007", correct: false },
    ],
  },
  {
    id: 3,
    question: "Who played the character of Harry Potter in the movies?",
    answers: [
      { text: "Johnny Depp", correct: false },
      { text: "Leonardo DiCaprio", correct: false },
      { text: "Denzel Washington", correct: false },
      { text: "Daniel Radcliffe", correct: true },
    ],
  },
  {
    id: 4,
    question: "What is the capital of Australia?",
    answers: [
      { text: "Sydney", correct: false },
      { text: "Melbourne", correct: false },
      { text: "Canberra", correct: true },
      { text: "Perth", correct: false },
    ],
  },
  {
    id: 5,
    question: "Which planet is known as the Red Planet?",
    answers: [
      { text: "Venus", correct: false },
      { text: "Mars", correct: true },
      { text: "Jupiter", correct: false },
      { text: "Saturn", correct: false },
    ],
  },
  {
    id: 6,
    question: "What is the largest ocean on Earth?",
    answers: [
      { text: "Atlantic Ocean", correct: false },
      { text: "Indian Ocean", correct: false },
      { text: "Arctic Ocean", correct: false },
      { text: "Pacific Ocean", correct: true },
    ],
  },
  {
    id: 7,
    question: "Who wrote the novel '1984'?",
    answers: [
      { text: "George Orwell", correct: true },
      { text: "Aldous Huxley", correct: false },
      { text: "Ray Bradbury", correct: false },
      { text: "H.G. Wells", correct: false },
    ],
  },
  {
    id: 8,
    question: "What is the chemical symbol for gold?",
    answers: [
      { text: "Go", correct: false },
      { text: "Gd", correct: false },
      { text: "Au", correct: true },
      { text: "Ag", correct: false },
    ],
  },
  {
    id: 9,
    question: "Which country has the most natural lakes?",
    answers: [
      { text: "Russia", correct: false },
      { text: "Canada", correct: true },
      { text: "Finland", correct: false },
      { text: "Sweden", correct: false },
    ],
  },
  {
    id: 10,
    question: "What is the fastest land animal?",
    answers: [
      { text: "Lion", correct: false },
      { text: "Cheetah", correct: true },
      { text: "Leopard", correct: false },
      { text: "Gazelle", correct: false },
    ],
  },
  {
    id: 11,
    question: "Which programming language was created by Guido van Rossum?",
    answers: [
      { text: "Java", correct: false },
      { text: "Python", correct: true },
      { text: "JavaScript", correct: false },
      { text: "C++", correct: false },
    ],
  },
  {
    id: 12,
    question: "What is the smallest country in the world?",
    answers: [
      { text: "Monaco", correct: false },
      { text: "San Marino", correct: false },
      { text: "Vatican City", correct: true },
      { text: "Liechtenstein", correct: false },
    ],
  },
  {
    id: 13,
    question: "Which element has the atomic number 1?",
    answers: [
      { text: "Helium", correct: false },
      { text: "Hydrogen", correct: true },
      { text: "Lithium", correct: false },
      { text: "Carbon", correct: false },
    ],
  },
  {
    id: 14,
    question: "Who painted the Mona Lisa?",
    answers: [
      { text: "Vincent van Gogh", correct: false },
      { text: "Pablo Picasso", correct: false },
      { text: "Leonardo da Vinci", correct: true },
      { text: "Michelangelo", correct: false },
    ],
  },
  {
    id: 15,
    question: "What is the largest mammal in the world?",
    answers: [
      { text: "African Elephant", correct: false },
      { text: "Blue Whale", correct: true },
      { text: "Giraffe", correct: false },
      { text: "Hippopotamus", correct: false },
    ],
  },
];